module.exports = __webpack_public_path__ + "static/img/ability-icon3.8603cf3.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/ability-icon3.png
// module id = imvA
// module chunks = 1